import { DataGrid, Form, Toolbar } from "devextreme-react";
import AuthFileUploader from "../../../common/AuthFileUploader";
import {
  Column,
  Editing,
  HeaderFilter,
  Paging,
  Scrolling,
  SearchPanel,
  Selection,
  Sorting,
} from "devextreme-react/data-grid";
import { Label, SimpleItem } from "devextreme-react/form";
import CustomStore from "devextreme/data/custom_store";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AuthFileUploaderEditor from "./FileUploaderEditor";
import {
  addOtherDocs,
  removeOtherDocs,
  updateDocs,
  updateECRF,
  updateECRFFilePath,
  updateIB,
  updateIBFilePath,
  updateICF,
  updateICFFilePath,
  updateOtherDocs,
  updatePCRF,
  updatePCRFFilePath,
  updatePRT,
  updatePRTFilePath,
  updateStep,
} from "./Redux/IRB";
import { Item } from "devextreme-react/toolbar";

export default function VersionTracking(props) {
  // const { step, setStep } = props;

  const dispatch = useDispatch();

  const IRB = useSelector((state) => state.IRB);

  const [otherDocumentsDataSource, setOtherDocumentsDataSource] =
    useState(null);

  useEffect(() => {
    setOtherDocumentsDataSource(
      new CustomStore({
        key: "title",
        load: () => {
          return IRB.otherDocs;
        },
        insert: (values) => {
          if (values.title) {
            dispatch(
              addOtherDocs({
                otherDocs: values,
              })
            );
          }
        },
        update: (key, values) => {
          dispatch(
            updateOtherDocs({
              otherDocs: {
                ...values,
                key: key,
              },
            })
          );
        },
        remove: (key) => {
          dispatch(
            removeOtherDocs({
              otherDocs: {
                title: key,
              },
            })
          );
        },
      })
    );
  }, [IRB.otherDocs]);

  const onPRTValueChanged = (e) => {
    dispatch(
      updatePRT({
        PRT: e.value,
      })
    );
  };

  const onIBValueChanged = (e) => {
    dispatch(
      updateIB({
        IB: e.value,
      })
    );
  };

  const onPCRFValueChanged = (e) => {
    dispatch(
      updatePCRF({
        pCRF: e.value,
      })
    );
  };

  const onECRFValueChanged = (e) => {
    dispatch(
      updateECRF({
        eCRF: e.value,
      })
    );
  };

  const onICFValueChanged = (e) => {
    dispatch(
      updateICF({
        ICF: e.value,
      })
    );
  };

  const onPRTFilePathValueChanged = (e) => {
    if (!e.value || e.value.length == 0) {
      dispatch(
        updatePRTFilePath({
          PRTFilePath: e.value,
        })
      );
    }
  };

  const onIBFilePathValueChanged = (e) => {
    if (!e.value || e.value.length == 0) {
      dispatch(
        updateIBFilePath({
          IBFilePath: e.value,
        })
      );
    }
  };

  const onPCRFFilePathValueChanged = (e) => {
    if (!e.value || e.value.length == 0) {
      dispatch(
        updatePCRFFilePath({
          pCRFFilePath: e.value,
        })
      );
    }
  };

  const onECRFFilePathValueChanged = (e) => {
    if (!e.value || e.value.length == 0) {
      dispatch(
        updateECRFFilePath({
          eCRFFilePath: e.value,
        })
      );
    }
  };

  const onICFFilePathValueChanged = (e) => {
    if (!e.value || e.value.length == 0) {
      dispatch(
        updateICFFilePath({
          ICFFilePath: e.value,
        })
      );
    }
  };

  const onUploadStarted = (e) => {};

  const onPRTUploaded = (e) => {
    dispatch(
      updatePRTFilePath({
        PRTFilePath: JSON.parse(e.request.response).filePath,
      })
      // updateDocs({
      //   docs: {
      //     title: "PRT",
      //     filePath: JSON.parse(e.request.response).filePath,
      //   },
      // })
    );

    // console.debug("IRB", IRB);
  };

  const onIBUploaded = (e) => {
    dispatch(
      updateIBFilePath({
        IBFilePath: JSON.parse(e.request.response).filePath,
      })
      // updateDocs({
      //   docs: {
      //     title: "IB",
      //     filePath: JSON.parse(e.request.response).filePath,
      //   },
      // })
    );
  };

  const onPCRFUploaded = (e) => {
    dispatch(
      updatePCRFFilePath({
        pCRFFilePath: JSON.parse(e.request.response).filePath,
      })
      // updateDocs({
      //   docs: {
      //     title: "pCRF",
      //     filePath: JSON.parse(e.request.response).filePath,
      //   },
      // })
    );
  };

  const onECRFUploaded = (e) => {
    dispatch(
      updateECRFFilePath({
        eCRFFilePath: JSON.parse(e.request.response).filePath,
      })
      // updateDocs({
      //   docs: {
      //     title: "eCRF",
      //     filePath: JSON.parse(e.request.response).filePath,
      //   },
      // })
    );
  };

  const onICFUploaded = (e) => {
    dispatch(
      updateICFFilePath({
        ICFFilePath: JSON.parse(e.request.response).filePath,
      })
      // updateDocs({
      //   docs: {
      //     title: "ICF",
      //     filePath: JSON.parse(e.request.response).filePath,
      //   },
      // })
    );
  };

  const editCellRender = (cellInfo) => {
    return (
      <AuthFileUploaderEditor
        cellInfo={cellInfo}
        contrNo={IRB.contrNo}
        siteNo={IRB.siteNo}
      />
    );
  };

  const allowEditing = (e) => {};

  const cellRender = (data) => {
    return (
      <div>
        {data.data.filePath
          ? data.data.filePath.substring(
              data.data.filePath.lastIndexOf("\\") + 1
            )
          : ""}
      </div>
    );
  };

  const prevItemOptions = {
    text: "PREVIOUS",
    onClick: () => {
      // setStep(1);
      dispatch(
        updateStep({
          step: 1,
        })
      );
    },
  };

  const nextItemOptions = {
    text: "NEXT",
    onClick: () => {
      // setStep(3);
      dispatch(
        updateStep({
          step: 3,
        })
      );
    },
  };

  return (
    <div
      style={{
        margin: "3px auto",
        width: "75vw",
      }}
    >
      <span style={{ fontWeight: 500, color: "#009688", marginLeft: "10px" }}>
        Version Tracking
      </span>
      <Form
        id="form-VersionTracking"
        labelMode="outside"
        labelLocation="top"
        showColonAfterLabel={true}
        style={{
          padding: "16px",
        }}
        colCount={5}
        validationGroup="versionTrackingData"
      >
        <SimpleItem
          dataField={"PRT"}
          // editorType={"dxNumberBox"}
          editorOptions={{
            value: IRB.PRT,
            showClearButton: true,
            onValueChanged: onPRTValueChanged,
          }}
        >
          <Label text={"PRT"} />
        </SimpleItem>
        <SimpleItem
          dataField={"IB"}
          // editorType={"dxNumberBox"}
          editorOptions={{
            value: IRB.IB,
            showClearButton: true,
            onValueChanged: onIBValueChanged,
          }}
        >
          <Label text={"IB"} />
        </SimpleItem>
        <SimpleItem
          dataField={"pCRF"}
          // editorType={"dxNumberBox"}
          editorOptions={{
            value: IRB.pCRF,
            showClearButton: true,
            onValueChanged: onPCRFValueChanged,
          }}
        >
          <Label text={"pCRF"} />
        </SimpleItem>
        <SimpleItem
          dataField={"eCRF"}
          // editorType={"dxNumberBox"}
          editorOptions={{
            value: IRB.eCRF,
            showClearButton: true,
            onValueChanged: onECRFValueChanged,
          }}
        >
          <Label text={"eCRF"} />
        </SimpleItem>
        <SimpleItem
          dataField={"ICF"}
          // editorType={"dxNumberBox"}
          editorOptions={{
            value: IRB.ICF,
            showClearButton: true,
            onValueChanged: onICFValueChanged,
          }}
        >
          <Label text={"ICF"} />
        </SimpleItem>
        <SimpleItem
          dataField={"PRTFilePath"}
          editorType={IRB.PRTFilePath ? "dxTextBox" : "dxFileUploader"}
          editorOptions={{
            value: IRB.PRTFilePath
              ? IRB.PRTFilePath.substring(IRB.PRTFilePath.lastIndexOf("\\") + 1)
              : IRB.PRTFilePath,
            showClearButton: true,
            onValueChanged: onPRTFilePathValueChanged,
          }}
        >
          <Label visible={false} />
          {!IRB.PRTFilePath && (
            <AuthFileUploader
              id="PRTFileUploader"
              uploadMode="instantly"
              uploadUrl={`${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/irb/${IRB.contrNo}/${IRB.siteNo}/PRT`}
              showFileList={true}
              disabled={IRB.PRT ? false : true}
              // onUploadStarted={onUploadStarted}
              onUploaded={onPRTUploaded}
            />
          )}
        </SimpleItem>
        <SimpleItem
          dataField={"IBFilePath"}
          editorType={IRB.IBFilePath ? "dxTextBox" : "dxFileUploader"}
          editorOptions={{
            value: IRB.IBFilePath
              ? IRB.IBFilePath.substring(IRB.IBFilePath.lastIndexOf("\\") + 1)
              : IRB.IBFilePath,
            showClearButton: true,
            onValueChanged: onIBFilePathValueChanged,
          }}
        >
          <Label visible={false} />
          {!IRB.IBFilePath && (
            <AuthFileUploader
              id="IBFileUploader"
              uploadMode="instantly"
              uploadUrl={`${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/irb/${IRB.contrNo}/${IRB.siteNo}/IB`}
              showFileList={true}
              // onUploadStarted={onUploadStarted}
              disabled={IRB.IB ? false : true}
              onUploaded={onIBUploaded}
            />
          )}
        </SimpleItem>
        <SimpleItem
          dataField={"pCRFFilePath"}
          editorType={IRB.pCRFFilePath ? "dxTextBox" : "dxFileUploader"}
          editorOptions={{
            value: IRB.pCRFFilePath
              ? IRB.pCRFFilePath.substring(
                  IRB.pCRFFilePath.lastIndexOf("\\") + 1
                )
              : IRB.pCRFFilePath,
            showClearButton: true,
            onValueChanged: onPCRFFilePathValueChanged,
          }}
        >
          <Label visible={false} />
          {!IRB.pCRFFilePath && (
            <AuthFileUploader
              id="pCRFFileUploader"
              uploadMode="instantly"
              uploadUrl={`${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/irb/${IRB.contrNo}/${IRB.siteNo}/pCRF`}
              showFileList={true}
              // onUploadStarted={onUploadStarted}
              disabled={IRB.pCRF ? false : true}
              onUploaded={onPCRFUploaded}
            />
          )}
        </SimpleItem>
        <SimpleItem
          dataField={"eCRFFilePath"}
          editorType={IRB.eCRFFilePath ? "dxTextBox" : "dxFileUploader"}
          editorOptions={{
            value: IRB.eCRFFilePath
              ? IRB.eCRFFilePath.substring(
                  IRB.eCRFFilePath.lastIndexOf("\\") + 1
                )
              : IRB.eCRFFilePath,
            showClearButton: true,
            onValueChanged: onECRFFilePathValueChanged,
          }}
        >
          <Label visible={false} />
          {!IRB.eCRFFilePath && (
            <AuthFileUploader
              id="eCRFFileUploader"
              uploadMode="instantly"
              uploadUrl={`${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/irb/${IRB.contrNo}/${IRB.siteNo}/eCRF`}
              showFileList={true}
              // onUploadStarted={onUploadStarted}
              disabled={IRB.eCRF ? false : true}
              onUploaded={onECRFUploaded}
            />
          )}
        </SimpleItem>
        <SimpleItem
          dataField={"ICFFilePath"}
          editorType={IRB.ICF ? "dxTextBox" : "dxFileUploader"}
          editorOptions={{
            value: IRB.ICFFilePath
              ? IRB.ICFFilePath.substring(IRB.ICFFilePath.lastIndexOf("\\") + 1)
              : IRB.ICFFilePath,
            showClearButton: true,
            onValueChanged: onICFFilePathValueChanged,
          }}
        >
          <Label visible={false} />
          {!IRB.ICFFilePath && (
            <AuthFileUploader
              id="ICFFileUploader"
              uploadMode="instantly"
              uploadUrl={`${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/irb/${IRB.contrNo}/${IRB.siteNo}/ICF`}
              showFileList={true}
              // onUploadStarted={onUploadStarted}
              disabled={IRB.ICF ? false : true}
              onUploaded={onICFUploaded}
            />
          )}
        </SimpleItem>
        <SimpleItem
          dataField={"otherDocuments"}
          editorType={"dxDataGrid"}
          colSpan={5}
        >
          <Label text={"Other Documents"} />
          <DataGrid
            id="OtherDocumentsGrid"
            dataSource={otherDocumentsDataSource}
            allowColumnReordering={true}
            allowColumnResizing={true}
            columnResizingMode="widget"
            rowAlternationEnabled={true}
            showBorders={true}
            showRowLines={true}
            showColumnLines={true}
            width={"100%"}
            height={"100%"}
            repaintChangesOnly={true}
            highlightChanges={true}
            columnAutoWidth={true}
            wordWrapEnabled={true}
            style={{
              maxHeight: "800px",
              marginBottom: "10px",
            }}
            // onInitNewRow={onInitNewRow}
          >
            <SearchPanel
              visible={true}
              highlightCaseSensitive={true}
              width={240}
            />
            <Scrolling
              mode={"virtual"}
              rowRenderingMode={"virtual"}
              columnRenderingMode={"virtual"}
              showScrollbar={"always"}
            />
            <HeaderFilter visible={true} />
            <Paging enabled={false} />
            <Sorting mode={"multiple"} />
            <Selection mode={"none"} />

            <Editing
              // mode={"batch"}
              mode={"cell"}
              startEditAction={"dblClick"}
              allowAdding={true}
              allowUpdating={true}
              allowDeleting={true}
            />

            <Column dataField={"title"} caption={"Title"} width={400} />
            <Column dataField={"version"} caption={"Version"} width={100} />
            <Column
              dataField={"filePath"}
              caption={"File"}
              //   cellTemplate={<AuthFileUploaderEditor />}
              editCellRender={editCellRender}
              //   allowEditing={allowEditing}
              cellRender={cellRender}
            ></Column>
          </DataGrid>
        </SimpleItem>
      </Form>
      <Toolbar>
        <Item
          location={"before"}
          widget={"dxButton"}
          options={prevItemOptions}
        />
        <Item
          location={"after"}
          widget={"dxButton"}
          options={nextItemOptions}
        />
      </Toolbar>
    </div>
  );
}
